module.exports = __webpack_public_path__ + "static/media/KN4@2x.93362739.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/KN/KN4@2x.png
// module id = 669
// module chunks = 0